import * as yup from 'yup'

export const defaultValues = {
  name: '',
  email: '',
  isConfirmed: 'nao'
}

export const recommendationModalSchema = yup.object({
  name: yup
    .string()
    .when('isConfirmed', ([isConfirmed], schema) =>
      isConfirmed === 'sim'
        ? schema.nullable().required('Informe o nome do colaborador')
        : schema
    ),
  email: yup
    .string()
    .email('Preencha um e-mail válido')
    .when('isConfirmed', ([isConfirmed], schema) =>
      isConfirmed === 'sim'
        ? schema.nullable().required('Informe o e-mail do colaborador')
        : schema
    ),
  isConfirmed: yup.string()
})
